"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPaymentOptionsFromRate = void 0;
const common_1 = require("../../../common");
function createPaymentOptionsFromRate(rate, options) {
    return [
        ...createPaymentOption(3, rate.threeYearFace, rate.threeYearPremium, options),
        ...createPaymentOption(4, rate.fourYearFace, rate.fourYearPremium, options),
        ...createPaymentOption(5, rate.fiveYearFace, rate.fiveYearPremium, options),
        ...createPaymentOption(7, rate.sevenYearFace, rate.sevenYearPremium, options),
        ...createPaymentOption(10, rate.tenYearFace, rate.tenYearPremium, options),
    ];
}
exports.createPaymentOptionsFromRate = createPaymentOptionsFromRate;
function createPaymentOption(years, faceAmount, premium, options) {
    if (!faceAmount || !premium) {
        return [];
    }
    return [
        {
            years,
            numberOfPayments: years * common_1.getPaymentsPerYear(options.paymentPeriod),
            faceAmount,
            premium,
            paymentMode: common_1.PaymentMode.Multi,
            paymentPeriod: options.paymentPeriod,
            amountOfFirstPayment: options.lumpSumAmount
                ? options.lumpSumAmount
                : premium + (options.downPaymentAmount || 0),
        },
    ];
}
//# sourceMappingURL=rate-payment-option-factory.js.map